import React from 'react';
import PropTypes from 'prop-types';
import Drawer from '@kyruus/drawer';
import CancelCircleOutline from '@kyruus/react-ikons/CancelCircleOutline';

// Import styled components from styles.js
import {
  DrawerContent,
  HeaderContainer,
  CloseButtonContainer,
  ContentContainer,
  CloseButton
} from './styles';

/**
 * MapPinSlideSheet component
 * A custom slide sheet/drawer specifically designed for map pin location details
 */
function MapPinSlideSheet({
  dataTestId,
  anchor,
  width,
  isOpen,
  id,
  ariaLabelledBy,
  children,
  onClose
}) {
  return (
    <Drawer
      id={id}
      data-testid={dataTestId}
      anchor={anchor}
      open={isOpen}
      variant="temporary"
      onClose={onClose}
      aria-labelledby={ariaLabelledBy}
      disableRestoreFocus={true}
    >
      <DrawerContent width={width}>
        <HeaderContainer>
          <CloseButtonContainer>
            <CloseButton
              mode="flat"
              onClick={(e) => onClose(e, 'closeClick')}
              aria-label="Close location details"
              data-testid="close-map-pin-drawer-button"
            >
              <CancelCircleOutline size="25px" />
            </CloseButton>
          </CloseButtonContainer>
        </HeaderContainer>
        <ContentContainer>{children}</ContentContainer>
      </DrawerContent>
    </Drawer>
  );
}

MapPinSlideSheet.propTypes = {
  dataTestId: PropTypes.string,
  anchor: PropTypes.oneOf(['left', 'right', 'top', 'bottom']),
  width: PropTypes.string,
  isOpen: PropTypes.bool,
  id: PropTypes.string.isRequired,
  ariaLabelledBy: PropTypes.string.isRequired,
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired
};

MapPinSlideSheet.defaultProps = {
  dataTestId: 'map-pin-slide-sheet',
  anchor: 'left',
  width: '70vw',
  isOpen: false
};

export default MapPinSlideSheet;
